/**
 * Checks if an object is empty or not
 *
 * @export
 * @param {Object} obj
 * @returns {Boolean}
 */
export default function isEmptyObj(obj) {
    if(obj.constructor !== Object) {
        throw new TypeError('Expected an Object as input')
    }
    return Object.entries(obj).length === 0
}
